export default {"src":"/_next/static/media/ic-credit-debit.bbe8621e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};